var map = {
	"./christmas-bells.ogg": "45b5",
	"./message.mp3": "617e",
	"./message.ogg": "cfea",
	"./notification.ogg": "7050",
	"./star-wars.ogg": "8ae6",
	"./tk-sound-halloween.ogg": "974c",
	"./tk-sound-navidad-2022.ogg": "f228"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "edc9";